import { service } from '@maia/cart';
import { queryOptions } from '@tanstack/react-query';

export function getProductsOptions(
  params: Parameters<typeof service.getMutationProducts>[number],
) {
  return queryOptions({
    queryFn: () => service.getMutationProducts(params),
    queryKey: ['getMutationProducts', params.customerGuid, params.cartGuid],
  });
}
